import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserGuideIcon from "../../../assets/images/guide.png";
import useUserStore from "../../../utils/storeApp";
import CallAPI from "../../../services/apiCalls";
import TwoFactorPreReg from "../TwoFactorPreReg";
import $ from "jquery";

const o = {
  ParentOrganizationId: 0,
  FirstName: "",
  NamePrefix: null,
  LastName: "",
  UserName: "",
  ContactEmail: "",
  RequireIdVerification: false,
  DirectEmail: false,
  Administrator: false,
  TrustedAgent: false,
  CreateUsers: false,
  Credential: "",
  ParentVendorId: "",
  UserType: null,
  TFAEmail: "",
  TFAPhone: "",
  TFAOn: false,
  TwoFactorEnabled: false,
};

const FormUserRegistration = () => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [submitFlag, SetSubmitFlag] = useState(false);
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [custObject, SetCustObject] = useState([]);
  const [orgObj, SetOrgObj] = useState([]);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [customer, setCustomer] = useState(null);
  const [errEmail, SetErrEmail] = useState(false);
  const [uNameErr, SetUNameErr] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };

  const GetOrgCustomer = () => {
    let vl = {};
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      if (el.id == userSession.vendor_id) {
        vl = el;
      }
    }
    setSelectedCustomer(vl);
  };
  const GetOrgs = () => {
    const temp = [];
    for (let el of sharedObject.getOrgsObj) {
      el.show = true;
      temp.push(el);
    }
    SetOrgObj(temp);
  };
  useEffect(() => {
    const listCust = async (id) => {
      let custId =
        userRole !== "SES ADMINISTRATOR" ? userSession.vendor_id : id;
      SetErrEmail(false);
      const temp = [];
      let vl = false;
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        if (el.id === custId) {
          vl = el;
        }
        temp.push(el);
      }
      SetCustObject(temp);
      let cust = `${custId}-${vl.trustedAgentAgreement}-${vl.twoFactorAuth}`;
      await setAnswers({
        ...answers,
        ParentVendorId: cust,
        RequireIdVerification: true,
      });
      //setAnswer("ParentVendorId", cust);
      setSelectedCustomer(vl);
      if (userRole === "SES ADMINISTRATOR") {
        CustomerIdSet(id, cust);
      }
    };
    let obj = sharedObject.orgActionObjForUser;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      listCust(obj.vendorId);
      if (userRole !== "SES ADMINISTRATOR") {
        GetOrgs();

        const foundOrganization = sharedObject.getOrgsObj?.find(
          (x) => x.id === obj.id
        );
        setSelectedOrganization(foundOrganization);

        setAnswer("ParentOrganizationId", obj.id);
        GetOrgCustomer();
      } //  else {
      //   CustomerIdSet(obj.vendorId, vendorVal);
      // }
    } else {
      listCust();
      if (userRole !== "SES ADMINISTRATOR") {
        GetOrgCustomer();
        GetOrgs();
      }
    }
  }, []);
  useEffect(() => {
    if (sharedObject.AddTfaFlag) {
      setAnswer("TwoFactorEnabled", false);
      SetSharedObject("AddTfaFlag", false);
    }
  }, [sharedObject.AddTfaFlag]);

  const CustomerIdSet = async (el, ParentVendorId) => {
    if (el === "" || el === undefined) {
      SetOrgObj([]);
      return;
    }
    let cust = {};
    for (let els of sharedObject.vendorsObj) {
      if (els.id == el) {
        cust = els;
      }
    }
    setSelectedCustomer(cust);
    setCustomer(el);
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);

      const foundOrganization = sharedObject.getOrgsObj?.find(
        (x) => x.id === sharedObject.orgActionObjForUser?.id
      );
      setSelectedOrganization(foundOrganization);

      await setAnswers({
        ...answers,
        ParentOrganizationId: sharedObject.orgActionObjForUser?.id,
        ParentVendorId: ParentVendorId,
        RequireIdVerification: true,
      });
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };
  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };
  function validEmail(email) {
    const regex = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
    let bol = regex.test(email);
    return bol;
  }
  const AddUser = async () => {
    SetSubmitFlag(true);
    SetErrCreateMsg(false);
    SetErrEmail(false);
    SetUNameErr(false);
    if (!answers?.ParentVendorId && userRole === "SES ADMINISTRATOR") {
      document.getElementById("ParentVendorId").scrollIntoView();
      document.getElementById("ParentVendorId").focus();
      return;
    } else if (
      !answers.ParentOrganizationId &&
      userRole === "SES ADMINISTRATOR"
    ) {
      document.getElementById("ParentOrganizationId").scrollIntoView();
      document.getElementById("ParentOrganizationId").focus();
      return;
    } else if (!answers.FirstName) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (!answers.LastName) {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (answers.ContactEmail === "") {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    } else if (
      answers.ContactEmail !== "" &&
      !validEmail(answers.ContactEmail)
    ) {
      SetErrEmail(true);
      return;
    } else if (answers?.UserName === "") {
      document.getElementById("UserName").scrollIntoView();
      document.getElementById("UserName").focus();
      return;
    } else if (
      answers?.UserName !== "" &&
      containsSpacesOrSpecialChars(answers?.UserName)
    ) {
      SetUNameErr(true);
      return;
      }
      if (answers.FirstName.length > 20) {
          document.getElementById("FirstName").scrollIntoView();
          document.getElementById("FirstName").focus();
          return;
      }
    let ans = {};
    if (answers.TwoFactorEnabled === true) {
      ans = {
        ...answers,
        TFAEmail: sharedObject.UserPreRegTwoFactor.contactEmail,
        TFAPhone: sharedObject.UserPreRegTwoFactor.phone,
        TFAOn: sharedObject.UserPreRegTwoFactor.tfaOn,
      };
    } else {
      ans = {
        ...answers,
        TFAEmail: "",
        TFAPhone: "",
        TFAOn: false,
      };
    }

    let val = sharedObject.specialties;
    let spec = [
      {
        Classification: val?.classification,
        Code: val?.code,
        Definition: val?.definition,
        Id: val?.id,
        Notes: val?.notes,
        Specialization: val?.specialization,
        Type: val?.type,
      },
    ];
    let answersObj = {
      ...ans,
      Specialties: spec,
      specializationCode: val?.code,
      ParentVendorId: customer,
      UserType: 0,
    };
    SetProcessing(true);
    let call = "/users/CreateUsers";
    const res = await CallAPI(call, answersObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      navigate("/registration-success");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
      }
      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
    // success navigate to={"/registration-success"}
  };

  return (
    <div className="FormUserRegistration">
      <div className="sp-pad">
        <div className="form-container">
          {userRole !== "SES ADMINISTRATOR" ? null : (
            <>
              <div className="field-wrapper">
                <label for="customer">Customer</label>
                <span className="filter-container dg-clr">
                  <input
                    className="form-control filter-sm"
                    type="search"
                    placeholder="Filter"
                    onChange={(el) => {
                      filterVendors(el.target.value);
                    }}
                  />
                </span>
                <select
                  size="5"
                  className="form-control"
                  id="ParentVendorId"
                  name="ParentVendorId"
                  onChange={(el) => {
                    setAnswer("ParentVendorId", el.target.value);
                    let val = el.target.value.split("-");
                    CustomerIdSet(val[0], el.target.value);
                  }}
                  value={answers?.ParentVendorId}
                >
                  <option value={``}>Select Customer</option>
                  {custObject?.map((el) => {
                    if (el.show)
                      return (
                        <option
                          key={el.id}
                          value={`${el.id}-${el.trustedAgentAgreement}-${el.twoFactorAuth}`}
                        >
                          {el.name}
                        </option>
                      );
                  })}
                </select>

                {!answers?.ParentVendorId && submitFlag ? (
                  <div className="alert alert-danger">
                    Customer is required.
                  </div>
                ) : null}
              </div>
            </>
          )}
          <div className="field-wrapper">
            <label for="Org">Organization</label>
            <span className="filter-container dg-clr">
              <input
                className="form-control filter-sm"
                type="search"
                placeholder="Filter"
                onChange={(el) => filterOrganiations(el.target.value)}
              />
            </span>

            {orgObj.length > 0 ? (
              <select
                size="5"
                className="form-control"
                name="ParentOrganizationId"
                id="ParentOrganizationId"
                onChange={(el) => {
                  setAnswer("ParentOrganizationId", parseInt(el.target.value));
                  const foundOrganization = sharedObject.getOrgsObj?.find(
                    (x) => x.id === parseInt(el.target.value)
                  );
                  setSelectedOrganization(foundOrganization);
                }}
                value={answers?.ParentOrganizationId}
              >
                <option value={``}>Select Organization</option>
                {orgObj?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
            ) : (
              <div className="watermark-wrapper">No Results</div>
            )}

            {!answers?.ParentOrganizationId && submitFlag ? (
              <div className="alert alert-danger">
                Organization is required.
              </div>
            ) : null}
          </div>
          <div className="field-wrapper spacer-inline spacer-margin5 v-top">
            {/*Prefix*/}
            <label for="prefix">Prefix</label>
            <select
              className="form-control field-ext"
              name="Prefix"
              onChange={(el) => {
                setAnswer("NamePrefix", parseInt(el.target.value));
              }}
              value={answers?.NamePrefix}
            >
              <option value="">Select</option>
              <option value={5}>Prof</option>
              <option value={4}>Dr</option>
              <option value={3}>Mrs</option>
              <option value={2}>Miss</option>
              <option value={1}>Mr</option>
              <option value={0}>Ms</option>
            </select>
          </div>
          {/*First Name*/}
          <div className="field-wrapper field-box4">
            <label for="FirstName">First Name</label>
            <input
              type="text"
              name="FirstName"
              id="FirstName"
              className="form-control"
              onChange={(el) => {
                setAnswer("FirstName", el.target.value);
              }}
              value={answers?.FirstName}
            />
            {!answers?.FirstName && submitFlag ? (
              <div className="alert alert-danger">First name is required.</div>
            ) : null}
            {answers.FirstName.length > 20  && submitFlag ? (
              <div className="alert alert-danger">Cannot be more than 20 characters</div>
            ) : null}
          </div>
          {/*Last Name*/}
          <div className="field-wrapper field-box2">
            <label for="LastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              name="LastName"
              id="LastName"
              onChange={(el) => {
                setAnswer("LastName", el.target.value);
              }}
              value={answers?.LastName}
            />
            {!answers?.LastName && submitFlag ? (
              <div className="alert alert-danger">Last name is required.</div>
            ) : null}
          </div>
          {/*Credential*/}
          <div className="field-wrapper field-box3 v-top">
            <label for="credential">Credential</label>
            <input
              className="form-control"
              name="credential"
              placeholder="Optional"
              onChange={(el) => {
                setAnswer("Credential", el.target.value);
              }}
              value={answers?.Credential}
            />
          </div>
          {/*Username*/}
          <div className="field-wrapper field-box7 v-top ">
            <label for="username">Username</label>
            <input
              className="form-control"
              name="UserName"
              id="UserName"
              onChange={(el) => {
                setAnswer("UserName", el.target.value);
              }}
              value={answers?.UserName}
            />
            {!answers?.UserName && submitFlag ? (
              <div className="alert alert-danger">Username is required. </div>
            ) : null}
            {uNameErr && submitFlag ? (
              <div className="alert alert-danger">
                Please enter a valid Username with no spaces, commas, or special
                characters.
              </div>
            ) : null}
          </div>
          {/*Contact Email*/}
          <div className="field-wrapper field-box8 v-top">
            <label for="ContactEmail">Contact Email</label>
            <input
              className="form-control"
              type="email"
              name="ContactEmail"
              id="ContactEmail"
              placeholder="Non-Direct"
              onChange={(el) => {
                setAnswer("ContactEmail", el.target.value);
              }}
              value={answers?.ContactEmail}
            />
            {!answers?.ContactEmail && submitFlag ? (
              <div className="alert alert-danger">
                Contact email is required.
              </div>
            ) : null}
            {errEmail && submitFlag ? (
              <div className="alert alert-danger">
                Please enter a valid email name with no spaces, commas, or
                special characters.
              </div>
            ) : null}
          </div>
          {/*Beginning of Verifications*/}
          <div className="field-wrapper title-divider">
            Verification &#38; Webmail
          </div>
          <div className="field-wrapper">
            <div className="w-lg2 spacer-inline">
              <section>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="RequireIdVerification"
                  id="RequireIdVerification"
                  onChange={(el) => {
                    setAnswer("RequireIdVerification", el.target.checked);
                  }}
                  value={answers?.RequireIdVerification}
                  checked={answers?.RequireIdVerification}
                  disabled={!selectedCustomer.trustedAgentAgreement}
                />
                <label>Require ID Proofing</label>
              </section>

              <section>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="DirectEmail"
                  id="DirectEmail"
                  onChange={(el) => {
                    setAnswer("DirectEmail", el.target.checked);
                  }}
                  value={answers?.DirectEmail}
                />
                <label>Direct Email</label>
              </section>
            </div>
            <div className="user-guide-wrapper">
              <a
                href="#UserGuide"
                data-toggle="collapse"
                aria-expanded="false"
                aria-controls="UserGuide"
                aria-describedby="User Guidlines"
              >
                <img
                  className="w-md4"
                  src={UserGuideIcon}
                  alt="User Guide Icon"
                  title="User Guide"
                />
              </a>
            </div>
          </div>
          {/*Verification User Guide*/}
          <div className="field-wrapper">
            <div className="collapse text-reg" id="UserGuide">
              <div className="spacer-margin7">
                As an admin, you will find that there are different ways to
                configure your options.
              </div>
              <ul>
                <li>
                  If required by the site settings, user identity has to be
                  verified during registration, unless it is done out-of-band.
                </li>
                <li>
                  Check "Direct Email" box if the user will need individual
                  Direct email account. Not all users need them, for example,
                  administrative users may not need their own Direct email.
                </li>
                <li>
                  Identity of the trusted agent must always be verified on-line
                  or out-of-band.
                </li>
                <li>
                  Trusted agent must always be an administrator and have ability
                  to create users.
                </li>
              </ul>
            </div>
          </div>

          {/*Beginning of Permissions Section*/}
          <div className="field-wrapper title-divider">Permissions</div>
          {/*Outbound XDR*/}
          <div className="field-wrapper">
            <section>
              <input
                className="form-control spacer-margin5"
                type="checkbox"
                name="Administrator"
                id="Administrator"
                onChange={(el) => {
                  setAnswer("Administrator", el.target.checked);
                }}
                value={answers?.Administrator}
              />
              <label>Administrator</label>
            </section>
            {selectedCustomer.trustedAgentAgreement &&
            userRole === "SES ADMINISTRATOR" ? (
              <section>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="TrustedAgent"
                  id="TrustedAgent"
                  onChange={(el) => {
                    setAnswer("TrustedAgent", el.target.checked);
                  }}
                  value={answers?.TrustedAgent}
                  disabled={!answers?.Administrator}
                />
                <label>Trusted Agent</label>
              </section>
            ) : null}
            <section>
              <input
                className="form-control spacer-margin5"
                type="checkbox"
                name="CreateUsers"
                id="CreateUsers"
                onChange={(el) => {
                  setAnswer("CreateUsers", el.target.checked);
                }}
                value={answers?.CreateUsers}
                disabled={!answers?.Administrator}
              />
              <label>Create Users</label>
            </section>
            {selectedOrganization?.twoFactorAuth ? (
              <section>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="TwoFactorEnabled"
                  id="TwoFactorEnabled"
                  onChange={(el) => {
                    setAnswer("TwoFactorEnabled", el.target.checked);
                    if (el.target.checked) {
                      $("#TwoFactorPreRegSettingModal").modal("show");
                    }
                  }}
                  checked={answers.TwoFactorEnabled}
                  value={answers.TwoFactorEnabled}
                />
                <label>Two-Factor Authentication</label>
                <span>
                  <a
                    href="#twoFactorInfo"
                    data-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="TwoFactorInfo"
                    aria-describedby="Two Factor Information"
                  >
                    <i className="bi bi-info-circle"></i>
                  </a>
                </span>
              </section>
            ) : null}
            <section className="collapse text-reg" id="twoFactorInfo">
              Two-factor authentication improves your digital security by
              protecting your account with an additional login step. It makes it
              harder for unauthorized users to gain access to an account without
              permission. A solid blue shield (indicating that two-factor
              authentication is on) or a shield with a slash (indicating that
              two-factor authentication is off) will appear next to each user in
              the list grid, depending on their settings. To modify these
              settings, click on the shield icon or adjust the settings in the
              user detail panel.
            </section>
            {errCreateMsg ? (
              <div
                className={`alert alert-danger`}
                dangerouslySetInnerHTML={{ __html: errMsg }}
              />
            ) : null}
          </div>
          {/*Register Action*/}
          <div className="button-register-container text-size4">
            <button
              onClick={(e) => AddUser()}
              type="button"
              className="btn btn-success"
            >
              Register
            </button>
            <Link
              type="button"
              className="btn btn-outline-secondary spacer-margin9"
              to="/Users"
            >
              Cancel
            </Link>
            {processing ? <div className="loading"></div> : null}
          </div>
        </div>
      </div>
      <TwoFactorPreReg />
    </div>
  );
};

export default FormUserRegistration;
